import request from '@/utils/request'

// export function getGroupTourList(data) {
//   return request({
//     url: '/SystemManagement/getFcmNoticeHistory',
//     method: 'post',
//     data
//   })
// }

export function getSdpHistory(data) {
  return request({
    url: '/SystemManagement/getSdpHistory',
    method: 'post',
    data,
  })
}

export function getFcmNoticeHistory(query) {
  return request({
    url: '/SystemManagement/getFcmNoticeHistory',
    method: 'get',
    params: query,
  })
}

export function getFcmTypeOption(query) {
  return request({
    url: '/SystemManagement/getFcmTypeOption',
    method: 'get',
    params: query,
  })
}

export function getRegionArea(query) {
  return request({
    url: '/SystemManagement/getRegionArea',
    method: 'get',
    params: query,
  })
}

export function saveRegionAreaPosition(data) {
  return request({
    url: '/SystemManagement/saveRegionAreaPosition',
    method: 'post',
    data,
  })
}

export function getCurrencies(query) {
  return request({
    url: '/SystemManagement/getCurrencies',
    method: 'get',
    params: query,
  })
}

export function saveCurrencies(data) {
  return request({
    url: '/SystemManagement/saveCurrencies',
    method: 'post',
    data,
  })
}

export function saveCity(data) {
  return request({
    url: '/SystemManagement/saveCity',
    method: 'post',
    data,
  })
}

export function deleteCity(data) {
  return request({
    url: '/SystemManagement/deleteCity',
    method: 'post',
    data,
  })
}

export function getAppPosition(data) {
  return request({
    url: '/SystemManagement/getAppPosition',
    method: 'post',
    data,
  })
}

export function getAppPositionTravelLog(data) {
  return request({
    url: '/SystemManagement/getAppPositionTravelLog',
    method: 'post',
    data,
  })
}

export function getUserPosition(query) {
  return request({
    url: '/SystemManagement/getUserPosition',
    method: 'get',
    params: query,
  })
}

export function getAppPositionTravelLogByID(query) {
  return request({
    url: '/SystemManagement/getAppPositionTravelLogByID',
    method: 'get',
    params: query,
  })
}

export function saveSysNotice(data) {
  return request({
    url: '/SystemManagement/saveSysNotice',
    method: 'post',
    data,
  })
}

export function deleteSysNotice(data) {
  return request({
    url: '/SystemManagement/deleteSysNotice',
    method: 'post',
    data,
  })
}

export function getSysNotice(query) {
  return request({
    url: '/SystemManagement/getSysNotice',
    method: 'get',
    params: query,
  })
}

export function getRangeSysNotice() {
  return request({
    url: '/SystemManagement/getRangeSysNotice',
    method: 'get',
  })
}
